import { connect } from "react-redux";
import { compose } from "redux";

import { getMatchNews } from "./actions";
import { MatchNews as Component } from "./matchNews";
import {
  makeSelectIsError,
  makeSelectIsReady,
  makeSelectNews,
} from "./reducer";

const makeMapStateToProps = () => {
  const selectNews = makeSelectNews();
  const selectIsReady = makeSelectIsReady();
  const selectIsError = makeSelectIsError();
  const mapStateToProps = (state, ownProps) => ({
    isReady: selectIsReady(state, ownProps),
    isError: selectIsError(state, ownProps),
    news: selectNews(state, ownProps),
  });

  return mapStateToProps;
};

const mapDispatchToProps = (dispatch) => ({
  onGetMatchNews: (data) => dispatch(getMatchNews(data)),
});

export default compose(connect(makeMapStateToProps, mapDispatchToProps))(
  Component
);
